import type { RouteRecordRaw } from 'vue-router'

export const MEAL = 'meal'
export const MEAL_DATE = 'meal-date'
export const MEAL_NAME = 'meal-name'

export default [
  {
    path: '/meal',
    name: MEAL,
    component: () => import('./views/Meal.vue'),
    children: [
      {
        path: ':date',
        name: MEAL_DATE,
        component: () => import('./views/Meal.vue'),
        children: [
          {
            path: ':name',
            name: MEAL_NAME,
            component: () => import('./views/Meal.vue'),
          },
        ],
      },
    ],
    meta: {
      auth: true,
    },
  },
] as RouteRecordRaw[]
